<template>
  <div class="footer">
    <a v-if="!$store.state.isLunchMap && !$store.state.isSchedule"
      class="left"
      :href="venuesListHref"
      target="_blank"
      rel="noopener">{{ $t('links') }}</a>
    <a v-if="!$store.state.isLunchMap && !$store.state.isSchedule" href="watchout/privacy-policy">{{ $t('privacy_policy') }}</a>
    <div v-if="!$store.state.isLunchMap && !$store.state.isSchedule">
      {{ $t('run_bar') }}
      <a href="watchout/admin/register/">{{ $t('register') }}</a>
      {{ $t('or') }}
      <a href="watchout/oferta" target="_blank">{{ $t('see_offer') }}</a>
    </div>
    <template v-if="$store.state.isLunchMap">
      <a href="/menu-lunchowe">{{ $t('links') }}</a>
      <a href="/regulamin">{{ $t('schedule_footer_terms') }}</a>
      <a href="/polityka-prywatnosci">{{ $t('privacy_policy') }}</a>
      <a href="watchout/admin/register/">{{ $t('register') }}</a>
      <a v-if="contactEmail" :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
      <div>
        {{ $t('place_owner') }}
        <a href="watchout/admin">login</a>
        ·
        <a href="watchout/auth/login/facebook/">Facebook</a>
      </div>
    </template>
    <template v-if="$store.state.isSchedule">
      <a href="/harmonogram-zajec">{{ $t('schedule_show_list') }}</a>
      <a href="/regulamin">{{ $t('schedule_footer_terms') }}</a>
      <a href="/polityka-prywatnosci">{{ $t('schedule_footer_privacy') }}</a>
      <a v-if="contactEmail" :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
    </template>
    <div v-if="!$store.state.isLunchMap">
      {{ $t('place_owner') }}
      <a href="watchout/admin">
        login
      </a>
    </div>
  </div>
</template>

<script>
const DEFAULT_VENUES_LIST_HREF = '/gdzie-ogladac-transmisje-sportowe'

export default {
  computed: {
    venuesListHref () {
      const lang = (this.$store.state.currentLanguage || (this.$i18n && this.$i18n.locale) || 'pl').toLowerCase()
      return lang.startsWith('en')
        ? '/en/where-to-watch-sports-broadcasts'
        : DEFAULT_VENUES_LIST_HREF
    },
    contactEmail () {
      const fromWindow = typeof window !== 'undefined' && window.__SITE_CONTACT_EMAIL__
      if (typeof fromWindow === 'string' && fromWindow.trim()) {
        return fromWindow.trim()
      }
      if (this.$store.state.isLunchMap) {
        return 'contact@lunchmap.pl'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    flex-shrink: 0;
    text-align: right;
    padding: 1 / 3 * $default-gap-size $default-gap-size / 2;
    padding-bottom: calc(#{1 / 3 * $default-gap-size} + env(safe-area-inset-bottom, 0px));
    color: $primary-background-color;
    background-color: $primary-inactive-element-color;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 0.55rem 1.25rem;
    & > * {
      display: inline-block;
      margin: 0;
    }
    a {
      display: inline-flex;
      color: $primary-accents-color;
    }
  }
</style>
